export default __webpack_public_path__ + "ce9912ab17005f536bd4d2479349a79f.svg";